import DataTable from "react-data-table-component"
import { SyncLoader } from "react-spinners"
import NoDataPrompt from "../NoDataPrompt/NoDataPrompt"
import "./Table.css"
// import { wrap } from "module"
// import { wrap } from "module"

const parseDate = (dateString) => {
  if (
    dateString === "None" ||
    dateString === "N/A" ||
    dateString === "Invalid date"
  ) {
    return null
  }

  if (dateString.includes("-")) {
    // MM-DD-YYYY format
    const parts = dateString.split("-")
    const month = parseInt(parts[0])
    const day = parseInt(parts[1])
    const year = parseInt(parts[2])
    return new Date(year, month - 1, day)
  } else {
    // Jan 10, 2023 format
    const parts = dateString.split(" ")
    const month = parts[0]
    const day = parseInt(parts[1].replace(",", ""))
    const year = parseInt(parts[2])
    const monthIndex = monthToIndex(month)
    if (monthIndex === -1) {
      return null
    }
    return new Date(year, monthIndex, day)
  }
}

const monthToIndex = (month) => {
  const fullMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]

  const abbreviatedMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]

  const fullMonthIndex = fullMonths.indexOf(month)
  const abbreviatedMonthIndex = abbreviatedMonths.indexOf(month)

  if (fullMonthIndex !== -1) {
    return fullMonthIndex
  } else if (abbreviatedMonthIndex !== -1) {
    return abbreviatedMonthIndex
  } else {
    return -1
  }
}

const parseMonthYear = (dateString) => {
  if (dateString === "None" || dateString === "N/A") {
    return null
  }

  const monthYearParts = dateString.split(" ")
  const month = monthYearParts[0]
  const year = parseInt(monthYearParts[1])

  const monthIndex = monthToIndex(month)
  if (monthIndex === -1) {
    return null
  }

  return new Date(year, monthIndex, 1)
}

function convertToSortableTime(timeString) {
  const [timePart, period] = timeString.split(" ")
  const [hours, minutes] = timePart.split(":").map(Number)
  const hours24 =
    period === "AM"
      ? hours === 12
        ? 0
        : hours
      : hours === 12
      ? 12
      : hours + 12
  return hours24 * 60 + minutes
}

export default function TableWithDynamicPagination({
  tableHeaders,
  headerSelector,
  tableData,
  ActionBtn,
  ViewBtn,
  PendingBtn,
  showLoader,
  withActionData,
  SaleBtn,
  ContractBtn,
  SaleBillingBtn,
  checkBtn,
  CheckBox,
  newTabBtn,
  tableType,
  OngoingPOBadges,
  DoneBtn,
  PaymentBtn,
  InvoiceBtn,
  materialsList,
  branchStatus,
  DepositedBtn,
  InvVarianceBtn,
  CashVarianceBtn,
  TotalVarianceBtn,
  currentAging,
  oneToThirty,
  thirtyOneToSixty,
  sixtyOneToNinety,
  aboveNinetyAging,
  totalItems,
  currentPage,
  itemsPerPage,
  handlePageChange,
}) {
  const columns = tableHeaders.map((header, index) => {
    if (header === "-") {
      return {
        name: "",
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: ViewBtn,
        width: "5rem",
        reorder: false,
        wordWrap: "break-word",
        wrap: true,
      }
    }
    if (header === "/") {
      return {
        name: "",
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: DoneBtn,
        width: "8rem",
        reorder: false,
        wordWrap: "break-word",
      }
    }
    if (header === "^") {
      return {
        name: "",
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: ContractBtn,
        width: "8rem",
        reorder: false,
        wordWrap: "break-word",
      }
    } else if (header.includes("PREP. BY") || header.includes("APPR. BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header === "DATE OPENED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.opening_start)
          const valueB = parseDate(b.opening_start)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "FRANCH. DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.franchised_on)
          const valueB = parseDate(b.franchised_on)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "JOB ORDER DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.franchised_on)
          const valueB = parseDate(b.franchised_on)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "TRANSFER DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.franchised_on)
          const valueB = parseDate(b.franchised_on)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "RECEIVE DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.franchised_on)
          const valueB = parseDate(b.franchised_on)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "MONTH") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseMonthYear(a.monthYear)
          const valueB = parseMonthYear(b.monthYear)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
      /* } else if (header === "SALES") {
            return {
                name: header,
                selector: (row) => row[headerSelector[index]],
                sortable: true,
                width: "8rem",
                left: true,
                reorder: true,
                wrap: true,
                sortFunction: (a, b) => {
                    const valueA = parseFloat(a.total_sale.replaceAll(',', '')) || parseFloat(a.sale.replaceAll(',', ''));
                    const valueB = parseFloat(b.total_sale.replaceAll(',', '')) || parseFloat(a.sale.replaceAll(',', ''));
                    if (valueA < valueB) {
                    return -1;
                    }
                    if (valueA > valueB) {
                    return 1;
                    }
                    return 0;
                },
            }; */
    } else if (header === "AVG SALES") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.average_sales.replaceAll(",", ""))
          const valueB = parseFloat(b.average_sales.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "NET SALES") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.total_net.replaceAll(",", ""))
          const valueB = parseFloat(b.total_net.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMT DUE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.total_amount_due.replaceAll(",", ""))
          const valueB = parseFloat(b.total_amount_due.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DISCOUNT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.discount.replaceAll(",", ""))
          const valueB = parseFloat(b.discount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "SUBTOTAL") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.subtotal.replaceAll(",", ""))
          const valueB = parseFloat(b.subtotal.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "TOTAL") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(
            a.grand_total.replaceAll(",", "") || a.total.replaceAll(",", "")
          )
          const valueB = parseFloat(
            b.grand_total.replaceAll(",", "") || b.total.replaceAll(",", "")
          )
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PAID AMT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.paid_amount.replaceAll(",", ""))
          const valueB = parseFloat(b.paid_amount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "BAL" || header === "BAL.") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.balance.replaceAll(",", ""))
          const valueB = parseFloat(b.balance.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMT. PAID") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount_paid.replaceAll(",", ""))
          const valueB = parseFloat(b.amount_paid.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount.replaceAll(",", ""))
          const valueB = parseFloat(b.amount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "SE NO.") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PREP BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PREPARED BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "REQUESTED BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "REVIEWD BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "REVIEWED BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "APPROVED BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "APV BY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id.replaceAll(",", ""))
          const valueB = parseFloat(b.id.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMT PAID") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount_paid.replaceAll(",", ""))
          const valueB = parseFloat(b.amount_paid.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "CUR QTY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.current_qty.replaceAll(",", ""))
          const valueB = parseFloat(b.current_qty.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "QTY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.quantity.replaceAll(",", ""))
          const valueB = parseFloat(b.quantity.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMT APPLIED TO INV") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(
            a.amount_applied_to_invoice.replaceAll(",", "")
          )
          const valueB = parseFloat(
            b.amount_applied_to_invoice.replaceAll(",", "")
          )
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PMT AMT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount.replaceAll(",", ""))
          const valueB = parseFloat(b.amount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "MIN") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "5rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.min.replaceAll(",", ""))
          const valueB = parseFloat(b.min.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "MAX") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "5rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.max.replaceAll(",", ""))
          const valueB = parseFloat(b.max.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PHYS COUNT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.physical_count.replaceAll(",", ""))
          const valueB = parseFloat(b.physical_count.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "COM COUNT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.computer_count.replaceAll(",", ""))
          const valueB = parseFloat(b.computer_count.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "BRKDN VALUE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.value_from.replaceAll(",", ""))
          const valueB = parseFloat(b.value_from.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "TOTAL SALES") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(
            a.total_sales.replaceAll(",", "") ||
              a.grand_total.replaceAll(",", "")
          )
          const valueB = parseFloat(
            b.total_sales.replaceAll(",", "") ||
              b.grand_total.replaceAll(",", "")
          )
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "TOTAL GROSS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.total_gross.replaceAll(",", ""))
          const valueB = parseFloat(b.total_gross.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "TOTAL REVENUE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.total_revenue.replaceAll(",", ""))
          const valueB = parseFloat(b.total_revenue.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "TOTAL PAID") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.total_paid.replaceAll(",", ""))
          const valueB = parseFloat(b.total_paid.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "GRAND TOTAL") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount.replaceAll(",", ""))
          const valueB = parseFloat(b.amount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMOUNT PAID") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.paid_amount.replaceAll(",", ""))
          const valueB = parseFloat(b.paid_amount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "BALANCE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.balance.replaceAll(",", ""))
          const valueB = parseFloat(b.balance.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PRICE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.price.replaceAll(",", ""))
          const valueB = parseFloat(b.price.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "AMOUNT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount.replaceAll(",", ""))
          const valueB = parseFloat(b.amount.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DOC NO" && tableType === "builditem") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.id)
          const valueB = parseFloat(b.id)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "CONTRACT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.contract.replaceAll(",", ""))
          const valueB = parseFloat(b.contract.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "MONTHLY BILLABLES") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "12vw",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.sale_billing.replaceAll(",", ""))
          const valueB = parseFloat(b.sale_billing.replaceAll(",", ""))
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE ISSUED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.issue_date || a.issued_date)
          const valueB = parseDate(b.issue_date || b.issued_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE ADDED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.date_added || a.date)
          const valueB = parseDate(b.date_added || b.date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE PAID") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.payment_date)
          const valueB = parseDate(b.payment_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DEP DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.deposit_date)
          const valueB = parseDate(b.deposit_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "CHK DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.check_date)
          const valueB = parseDate(b.check_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PO DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.purchase_date)
          const valueB = parseDate(b.purchase_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(
            a.count_date ||
              a.receive_date ||
              a.supplies_expense_date ||
              a.expense_date ||
              a.supplies_receive_date ||
              a.date ||
              a.added_on ||
              a.wastage_date
          )
          const valueB = parseDate(
            b.count_date ||
              b.receive_date ||
              b.supplies_expense_date ||
              b.expense_date ||
              b.supplies_receive_date ||
              b.date ||
              b.added_on ||
              b.wastage_date
          )
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DISBURSEMENT DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(
            a.count_date ||
              a.receive_date ||
              a.supplies_expense_date ||
              a.expense_date ||
              a.supplies_receive_date ||
              a.date ||
              a.added_on ||
              a.wastage_date
          )
          const valueB = parseDate(
            b.count_date ||
              b.receive_date ||
              b.supplies_expense_date ||
              b.expense_date ||
              b.supplies_receive_date ||
              b.date ||
              b.added_on ||
              b.wastage_date
          )
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "VALID DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(
            a.count_date ||
              a.receive_date ||
              a.supplies_expense_date ||
              a.expense_date ||
              a.supplies_receive_date ||
              a.date ||
              a.added_on ||
              a.wastage_date
          )
          const valueB = parseDate(
            b.count_date ||
              b.receive_date ||
              b.supplies_expense_date ||
              b.expense_date ||
              b.supplies_receive_date ||
              b.date ||
              b.added_on ||
              b.wastage_date
          )
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "ENCODED ON") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.encoded_on || a.added_on)
          const valueB = parseDate(b.encoded_on || b.added_on)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE REQUESTED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.request_date)
          const valueB = parseDate(b.request_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DELIVERY DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.delivery_date)
          const valueB = parseDate(b.delivery_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE RECEIVED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseDate(a.received_date || a.date_received)
          const valueB = parseDate(b.received_date || b.date_received)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DATE TRANSFERRED" || header === "DATE TRANSFER") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
        sortFunction: (a, b) => {
          const valueA = parseDate(a.transfer_date)
          const valueB = parseDate(b.transfer_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "ORDER DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.order_date)
          const valueB = parseDate(b.order_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "RQT TIME") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        // left: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const timeA = convertToSortableTime(a.rqt_time)
          const timeB = convertToSortableTime(b.rqt_time)

          if (timeA < timeB) {
            return -1
          }
          if (timeA > timeB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "APPRVE TIME") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        // left: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const timeA = convertToSortableTime(a.approve_time)
          const timeB = convertToSortableTime(b.approve_time)

          if (timeA < timeB) {
            return -1
          }
          if (timeA > timeB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "SALES DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.sales_date)
          const valueB = parseDate(b.sales_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "DEPOSIT DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.deposited_on)
          const valueB = parseDate(b.deposited_on)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "RECEIVED DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.receive_date)
          const valueB = parseDate(b.receive_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PURCHASED DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseDate(a.purchase_date)
          const valueB = parseDate(b.purchase_date)
          if (valueA === null && valueB === null) {
            return 0
          }
          if (valueA === null) {
            return -1
          }
          if (valueB === null) {
            return 1
          }
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "+") {
      return {
        name: "",
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: PaymentBtn,
        width: "7rem",
        reorder: false,
        wordWrap: "break-word",
      }
    } else if (header === "*") {
      return {
        name: "",
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: CheckBox,
        width: "4vw",
        reorder: false,
        wordWrap: "break-word",
      }
    } else if (
      (header === "TRANSFER NO." || header === "TRANS NO.") &&
      tableType !== "gatepass"
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "7rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header === "PO") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: OngoingPOBadges,
        width: "8rem",
        left: true,
        reorder: false,
        wordWrap: "break-word",
      }
    } else if (header === ".") {
      return {
        name: "",
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: checkBtn,
        width: "3vw",
        reorder: false,
        wordWrap: "break-word",
      }
    } else if (
      header === "PMT REF NO" ||
      header === "PMT MODE" ||
      header === "PO No."
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: newTabBtn,
        width: "8rem",
        // left: true,
        reorder: false,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "SALES INVOICES") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: PendingBtn,
        width: "8rem",
        // left: true,
        reorder: false,
        wrap: true,
      }
    } else if (header === "RETURN DETAILS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: PendingBtn,
        width: "8%",
        reorder: false,
        wrap: true,
      }
    } else if (header === "TRANSFER NO." && tableType === "gatepass") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: PendingBtn,
        width: "8rem",
        reorder: false,
      }
    } else if (
      (header === "REPLACEMENT ID" || header === "RETURN NO.") &&
      tableType === "purchase return"
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: PendingBtn,
        width: "8%",
        reorder: false,
        wrap: true,
      }
    } else if (header === "INV NO." && tableType === "purchase return") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: newTabBtn,
        width: "8rem",
        reorder: false,
        wrap: true,
      }
    } else if (header === "INV NO.") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: InvoiceBtn,
        width: "8rem",
        reorder: false,
        wrap: true,
      }
    } else if (header === "DOC No.") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: newTabBtn,
        width: "8rem",
        reorder: false,
        wrap: true,
      }
    } else if (header === "INVOICES APPLIED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        cell: newTabBtn,
        width: "9%",
        reorder: false,
        wrap: true,
      }
    } else if (header === "ACTIONS" && !withActionData) {
      return {
        name: header,
        button: true,
        cell: ActionBtn,
        width: "5rem",
        reorder: false,
        center: true,
      }
    } else if (header === "   ") {
      return {
        name: header,
        button: true,
        cell: PendingBtn,
        width: "6vw",
        reorder: true,
        wordWrap: "break-word",
      }
    } else if (header === " ") {
      return {
        name: header,
        button: true,
        cell: PendingBtn,
        width: "8rem",
        reorder: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("DATE") || header === "SALES DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "PRODUCT NAME") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "8rem",
        reorder: true,
        wordWrap: "break-word",
      }
    } else if (header === "ITEM CODE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "8rem",
        reorder: true,
        wordWrap: "break-word",
      }
    } else if (header === "PHONE NUMBER") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "10rem",
        reorder: true,
        wordWrap: "break-word",
      }
    } else if (
      (header === "INV NO." || header === "CONT. NO.") &&
      tableType === "purchase return"
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "8rem",
        cell: InvoiceBtn,
        reorder: true,
        wrap: true,
      }
    } else if (
      header.includes("SALES") ||
      header.includes("BAL") ||
      header.includes("AMT") ||
      header.includes("DIS") ||
      header.includes("DISCOUNT") ||
      header.includes("DSC") ||
      header === "ORDER VALUE" ||
      header.includes("CONTRACT") ||
      header.includes("MONTHLY BILLABLES")
    ) {
      return {
        name: header,
        selector: (row) =>
          row[headerSelector[index]] === null
            ? "N/A"
            : row[headerSelector[index]]?.toLowerCase(),
        sortable: true,
        right: true,
        width: "8rem",
        cell: SaleBtn,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "CONTRACT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        button: true,
        width: "8rem",
        cell: ContractBtn,
        reorder: true,
      }
    } else if (
      header === "SOURCE ID" ||
      header === "UNDERTIME" ||
      header === "NO. OF UNFOLLOWED BREAKS"
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        button: true,
        width: "8rem",
        cell: ContractBtn,
        reorder: true,
        wordWrap: "break-word",
      }
    } else if (header === "FINAL TOTAL") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        button: true,
        width: "8rem",
        cell: ContractBtn,
        reorder: true,
        right: true,
      }
    } else if (header === "MONTHLY BILLABLES") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        button: true,
        width: "8rem",
        cell: SaleBillingBtn,
        reorder: true,
      }
    } else if (header === "RAW MATERIALS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        button: true,
        width: "8rem",
        cell: materialsList,
        reorder: true,
      }
    } else if (header === "BRANCH STATUS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        button: true,
        width: "8rem",
        cell: branchStatus,
        reorder: true,
      }
    } else if (header === "BRANCH") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        width: "8rem",
        cell: branchStatus,
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "TRADE NAME" || header === "TRADE ADDRESS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "21rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "DEPOSITED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        left: true,
        button: true,
        width: "8rem",
        cell: DepositedBtn,
        reorder: true,
      }
    } else if (header === "TOTAL VARIANCE" || header === "DIFFERENCE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        right: true,
        button: true,
        width: "8rem",
        cell: TotalVarianceBtn,
        reorder: true,
      }
    } else if (header === "CASH VARIANCE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        right: true,
        button: true,
        width: "8rem",
        cell: CashVarianceBtn,
        reorder: true,
      }
    } else if (header === "INV VARIANCE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]].toLowerCase(),
        right: true,
        button: true,
        width: "8rem",
        cell: InvVarianceBtn,
        reorder: true,
      }
    } else if (header.includes("FRANCHISEE NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header.includes("BRANCH NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "15rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("OPEN DAYS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("OPEN TIMES")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("PMT STATS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header === "EMPLOYEE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "IN" || header === "OUT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "12vw",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "COMPANY EMAIL") {
      return {
        name: header,
        selector: (row) =>
          row[headerSelector[index]] === null
            ? "N/A"
            : row[headerSelector[index]]?.toLowerCase(),
        left: true,
        width: "15rem",
        reorder: true,
        Cell: (row) => {
          const email = row.email
          if (!email) return ""
          return email.toLowerCase()
        },
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("SUPPLIER")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("COMPLETED ON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("COMPLETED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("DESCRIPTION")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("CANCELLED")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("CASHIER")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("EMPLOYEE NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("PAYEE ID")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("CASH SALES")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("PAYROLL RANGE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("DISBMT DATE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("REQUEST DATE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("NO. OF EMPLOYEE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("GROUP NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("NO. OF BRANCHES")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("SOURCE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("FOOD PANDA SALES")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("GRAB FOOD SALES")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("LAST SYNC")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }   
    } else if (header.includes("EXPENSE TYPE")) {
        return {
          name: header,
          selector: (row) => row[headerSelector[index]],
          sortable: true,
          width: "10rem",
          reorder: true,
          left: true,
          wrap: true,
        }
    } else if (header.includes("BANK")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("TRANSACTION TYPE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("SUBMITTED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("SUBMITTED ON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("CHECKED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("CHECKED ON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("POSTED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("POSTED ON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("DONE BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("DONE ON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("DEPOSITED AMT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("SYSTEM CASH AMT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("ADDED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("WASTAGE ITEMS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("CHARGE AMOUNT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("CHARGED TO")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("REASON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("WASTAGE BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("CA NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ESTIMATED TIME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("TIME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("OPERATION TIME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ACTIVITY LOG")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("DRIVER")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("PLATE NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ENCODED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("REQUEST FROM")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("REQUEST TO")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("DELIVERY PERSONNEL")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("BRKDN UNIT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ACCEPTABLE VARIANCE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ORDER NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ORDER NO")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("USAGE QTY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("CONTRACT STATUS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("ACKNOWLEDGE BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("BUILT ITEM")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("ITEM")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "15rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("CATEGORY AND SUBCATEGORY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("FLOAT QTY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        right: true,
        wrap: true,
      }
    } else if (header.includes("INV UNIT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
      }
    } else if (header.includes("BARCODE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("ITEM DESCRIPTION")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "20rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("ITEM CODE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      } 
    } else if (header.includes("CLASSIFICATION")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "12rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("BRANCH FROM")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("FROM")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("RECEIVED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("TO")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("BRANCH TO")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("ITEM NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("PAYEE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        left: true,
      }
    } else if (header.includes("BANK NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "20rem",
        reorder: true,
        wrap: true,
        right: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("PYMNT MODE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        left: true,
      }
    } else if (header === "PYMNT STATUS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        left: true,
      }
    } else if (header.includes("AMOUNT DUE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        right: true,
      }
    } else if (header.includes("DOC TYPE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("UNIT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("NOTED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("COMPANY NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "15rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("CONTACT PERSON")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "15rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header.includes("SUPPLIER/VENDOR")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("DR NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("PO NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("DOC NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        // sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (
      (header.includes("NO.") ||
        header.includes("no.") ||
        header === "CUR QTY" ||
        header === "BRKDN VALUE" ||
        header.includes("DR NO")) &&
      header !== "INV NO."
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
        // wrap: true,
      }
    } else if (header.includes("ROLE") || header.includes("TYPE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("REMARKS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("DAPPD BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("COUNTED BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("ADM REMARKS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        left: true,
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("USERNAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        sortable: true,
        width: "30vw",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header.includes("INITIAL CASH IN DRAWER")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header.includes("FULL NAME")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "15rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    }
    //  else if (header === "PAYMENT DATE" || header === "PAY DATE") {
    //     return {
    //         name: header,
    //         selector: (row) => row[headerSelector[index]],
    //         sortable: true,
    //         width: "14vw",
    //         reorder: true,
    //     };
    // }
    else if (header === "DETAILS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (
      header === "MIN" ||
      header === "MAX" ||
      header.includes("QTY") ||
      header.includes("Qty") ||
      header.includes("COUNT") ||
      // header.includes("DIFFERENCE")||
      header.includes("QUANTITY") ||
      header.includes("PRICE") ||
      header.includes("UNIT PRICE") ||
      header.includes("YIELD")
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header === "ADDRESS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "15rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else if (header === "DEPOSIT AMOUNT" || header === "TOTAL DEPOSIT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (
      header.includes("FEE") ||
      header.includes("USAGE") ||
      header.includes("BEGINNING") ||
      header.includes("TOTAL") ||
      header.includes("DELIVERED") ||
      header.includes("ACTUAL END") ||
      header.includes("SYSTEM END") ||
      header.includes("AMOUNT PAID") ||
      header.includes("PAID AMOUNT") ||
      header.includes("LOAN")
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
        // sortFunction: (a, b) => {
        //     // Convert the values to numbers for comparison
        //
        //     const valueA = parseFloat(a.amount);
        //     const valueB = parseFloat(b.amount);
        //
        //     if (valueA < valueB) {
        //     return -1;
        //     }
        //     if (valueA > valueB) {
        //     return 1;
        //     }
        //     return 0;
        // },
      }
    } else if (header === "OT HOURS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.overtime)
          const valueB = parseFloat(b.overtime)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "UNDERTIME") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.undertime)
          const valueB = parseFloat(b.undertime)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header.includes("STATUS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else if (header.includes("DISCOUNT VALUE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        right: true,
      }
    } else if (header.includes("BY")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "9vw",
        reorder: true,
        wrap: true,
      }
    } else if (header === "AMOUNT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.amount)
          const valueB = parseFloat(b.amount)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header.includes("BALANCE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.balance)
          const valueB = parseFloat(b.balance)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "REGULAR WORKING HOURS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.regular_working_hours)
          const valueB = parseFloat(b.regular_working_hours)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "PAYABLE PER CYCLE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.payable_per_payroll)
          const valueB = parseFloat(b.payable_per_payroll)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "UNDERTIME HOURS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.undertime)
          const valueB = parseFloat(b.undertime)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "OVERTIME HOURS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.overtime)
          const valueB = parseFloat(b.overtime)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "WORKING HOURS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        right: true,
        reorder: true,
        wrap: true,
        sortFunction: (a, b) => {
          const valueA = parseFloat(a.total_hours)
          const valueB = parseFloat(b.total_hours)
          if (valueA < valueB) {
            return -1
          }
          if (valueA > valueB) {
            return 1
          }
          return 0
        },
      }
    } else if (header === "CURRENT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]]?.toLowerCase(),
        cell: currentAging,
        reorder: true,
        // left: true,
        // width:"11vw"
        width: "8rem",
      }
    } else if (header === "1-30") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]]?.toLowerCase(),
        cell: oneToThirty,
        reorder: true,
        left: true,
        // width:"11vw"
        width: "8rem",
      }
    } else if (header === "31-60") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]]?.toLowerCase(),
        cell: thirtyOneToSixty,
        reorder: true,
        left: true,
        // width:"11vw"
        width: "8rem",
      }
    } else if (header === "61-90") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]]?.toLowerCase(),
        cell: sixtyOneToNinety,
        reorder: true,
        left: true,
        // width:"11vw"
        width: "8rem",
      }
    } else if (header === "ABOVE 90") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]]?.toLowerCase(),
        cell: aboveNinetyAging,
        reorder: true,
        left: true,
        // width:"11vw"
        width: "8rem",
      }
    } else if (header === "CUSTOMER") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "10rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header === "RANK") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "DATE ISSUED") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "10rem",
        reorder: true,
      }
    } else if (header === "SUPPLIER") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "10rem",
        reorder: true,
        left: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header === "QTY SOLD") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "REVENUE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if ( (header === "SELLING PRICE") || (header === "UNIT PRICE") ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "COST") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "DISCOUNT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "DISCOUNT DETAILS") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "PROFIT") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "PROFIT MARGIN") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        width: "8rem",
        reorder: true,
      }
    } else if (header === "CATEGORY") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        left: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    } else if (header === "NAME" && tableType === "category") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word",
      }
    } else {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
        wordWrap: "break-word", 
      }
    }
  })

  const paginationComponentOptions = {
    rowsPerPageText: "",
    noRowsPerPage: true,
  }

  const customStyles = {
    rows: {
      style: {
        minHeight: "5.2vh",
        // minWidth: "90rem", //para adjust sa width sa table
        maxWidth: "150rem",
      },
    },
  }

  return showLoader ? (
    <div className="d-flex justify-content-center my-5">
       <SyncLoader color="var(--primary-color)" size={15} />
    </div>
  ) : (
    <DataTable
      pagination
      // pagination={tableType === "item_history" ? false : true}
      striped
      fixedHeader
      fixedHeaderScrollHeight="50vh"
      columns={columns}
      data={tableData}
      customStyles={customStyles}
      paginationComponentOptions={paginationComponentOptions}
      noDataComponent={<NoDataPrompt />}
      paginationTotalRows={totalItems} // Total number of items for pagination
      paginationPerPage={itemsPerPage} // Items per page
      paginationServer={true} // Enable server-side pagination
      onChangePage={handlePageChange} // Function to handle page change
      currentPage={currentPage}
      paginationDefaultPage={currentPage}
      // defaultSortFieldId={tableType === 'itemList' && 2}
    />
  )
}
